// KpiStrip — KPI tiles laid out in a 1px-bordered grid.
//
// By default tiles[] are spread evenly across one row.
// Pass `cols` to fix the number of columns; rows wrap automatically.
//
// Each tile:
//   { key?, label, value, unit?, sub?, trend?, inverseTrend?, accent? }
import React from 'react'
import { theme as defaultTheme, T } from './tokens'
import { Trend } from './primitives'

export default function KpiStrip({ tiles = [], cols, theme = defaultTheme }) {
  if (tiles.length === 0) return null
  const columns = cols || tiles.length
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      gap: 1,
      background: theme.border,
      border: `1px solid ${theme.border}`,
      borderRadius: 10, overflow: 'hidden',
    }}>
      {tiles.map((t, i) => (
        <KpiTile key={t.key ?? t.label ?? i} theme={theme} {...t} />
      ))}
    </div>
  )
}

function KpiTile({ theme, label, value, unit, sub, trend, inverseTrend = false, accent }) {
  return (
    <div style={{ background: theme.surface, padding: '14px 16px', minHeight: 96 }}>
      <div style={{
        fontSize: 10, fontWeight: 700, color: theme.textDim,
        letterSpacing: 0.6, textTransform: 'uppercase',
        marginBottom: 8, fontFamily: T.fontUI,
      }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{
          fontFamily: T.fontMono, fontSize: 24, fontWeight: 600,
          color: accent ?? theme.text,
          letterSpacing: -1, lineHeight: 1,
        }}>{value ?? '—'}</span>
        {unit && (
          <span style={{ fontSize: 11, color: theme.textDim, fontFamily: T.fontUI }}>{unit}</span>
        )}
        {trend != null && (
          <span style={{ marginLeft: 'auto' }}>
            <Trend value={trend} theme={theme} inverse={inverseTrend} />
          </span>
        )}
      </div>
      {sub && (
        <div style={{ marginTop: 6, fontSize: 11, color: theme.textSub, lineHeight: 1.4 }}>
          {sub}
        </div>
      )}
    </div>
  )
}

export { KpiTile }
